// extracted by mini-css-extract-plugin
export default {"supportingEvidencePagePillButtons":"SupportingEvidence_supportingEvidencePagePillButtons__92UiZ"};